module.exports = __webpack_public_path__ + "img/yewushuju.75e07329.png";